export { WidgetAppTemplate } from './WidgetAppTemplate'
